<template>
    <!-- <div>
    <section>-->
    <!-- <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" height="1000"> -->
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="gourmet">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold brown--text text--darken-4"
                                >Gourmet</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cerrar</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout row>
                            <v-flex xs12>
                                <v-container fluid>
                                    <v-row align="center">
                                        <v-col
                                            v-for="producto in productosGourmet"
                                            :key="producto.id"
                                        >
                                            <v-card :max-width="imgWidth" class="mx-auto">
                                                <v-img
                                                    :src="producto.imagen"
                                                    :lazy-src="producto.imagen_blur"
                                                    class="align-end"
                                                    :width="imgWidth"
                                                    gradient="to bottom left, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                >
                                                    <!-- class="red--text text--darken-2" -->
                                                    <v-card-title
                                                        class="red--text text--lighten-4"
                                                        style="white-space:pre-wrap;"
                                                        v-text="producto.nombre"
                                                    ></v-card-title>
                                                    <v-card-text class="red--text text--lighten-4">
                                                        <div
                                                            class="subtitle-1 font-weight-medium red--text text--lighten-1"
                                                        >{{ producto.precio }}</div>
                                                        <v-rating
                                                            :value="producto.rating"
                                                            color="amber"
                                                            dense
                                                            half-increments
                                                            readonly
                                                            size="14"
                                                        ></v-rating>
                                                        <div>{{ producto.descripcion }}</div>
                                                    </v-card-text>

                                                    <template v-slot:placeholder>
                                                        <v-row
                                                            class="fill-height ma-0"
                                                            align="center"
                                                            justify="center"
                                                        >
                                                            <v-progress-circular
                                                                indeterminate
                                                                color="grey lighten-5"
                                                            ></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <!-- </section> -->
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- </div> -->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'gourmet',
    data() {
        return {};
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    created() {
        this.$store.dispatch('fetchProductosGourmet');
    },
    computed: {
        ...mapGetters(['waitCursor', 'navMainLogo', 'productosGourmet']),

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },
        imgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '440px';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '410px';
            } else if (this.$vuetify.breakpoint.md) {
                width = '380px';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '350px';
            } else {
                width = '320px';
            }
            return width;
        },

        breakPoint() {
            var bkPoint = 'xs';
            if (this.$vuetify.breakpoint.sm) {
                bkPoint = 'sm';
            } else if (this.$vuetify.breakpoint.md) {
                bkPoint = 'md';
            } else if (this.$vuetify.breakpoint.lg) {
                bkPoint = 'lg';
            } else if (this.$vuetify.breakpoint.xl) {
                bkPoint = 'xl';
            }
            return bkPoint;
        }
    },
    methods: {
        onClose() {
            this.$router.push('/');
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}
.gourmet {
    /* background: url('../assets/maksym-kaharlytskyi-3uJt73tr4hI-unsplash1.png'); */
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}
.bourbon {
    font-family: 'bourbon';
    font-weight: bold;
}

.catabocata-red {
    color: #bc1212;
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    /* font-size: 2.8em; */
    /* font-size: 500px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>

